import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=0a48d276&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"
import style0 from "./modal.vue?vue&type=style&index=0&id=0a48d276&prod&lang=scss&"
import style1 from "./modal.vue?vue&type=style&index=1&id=0a48d276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48d276",
  null
  
)

export default component.exports